import Swiper from "swiper";
import {
  Navigation,
  Pagination,
  Autoplay,
  EffectFade,
  Controller,
} from "swiper/modules";

function refreshHomeSlideAnimation() {
  document
    .querySelectorAll(".home-slider .swiper-slide")
    .forEach((el) => el.classList.remove("is-animate"));
  document
    .querySelectorAll(".home-slider .swiper-slide-active")
    .forEach((el) => el.classList.add("is-animate"));
}

export default function () {
  let homeSlide = new Swiper(".home-slider", {
    modules: [Navigation, Pagination, Autoplay, EffectFade],
    slidesPerView: 1,
    speed: 1500,
    effect: "fade",
    navigation: {
      nextEl: ".next-slide-home",
      prevEl: ".prev-slide-home",
    },
    pagination: {
      el: ".home-pagination",
      clickable: true,
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    rewind: true,
    on: {
      init: refreshHomeSlideAnimation,
      transitionStart: refreshHomeSlideAnimation,
    },
  });

  let bestSeller = new Swiper(".slider-best-sellers", {
    modules: [Pagination, Navigation],
    slidesPerView: 4,
    spaceBetween: 30,
    loop: true,
    navigation: {
      nextEl: ".swiper-best-sellers-button-next",
      prevEl: ".swiper-best-sellers-button-prev",
    },
    pagination: {
      el: ".swiper-best-sellers-pagination",
      type: "bullets",
      clickable: true,
    },
    breakpoints: {
      650: {
        slidesPerView: 1,
        // spaceBetween: 20
      },
      800: {
        slidesPerView: 2,
      },

      900: {
        slidesPerView: 3,
        // spaceBetween: 30
      },
    },
  });

  if (document.querySelector(".multipleslider-wrapper")) {
    let multipleMain = new Swiper(".slider-main.-nologo", {
      modules: [Navigation, Controller],
      slidesPerView: 1,
      spaceBetween: 20,
      speed: 2000,
      navigation: {
        nextEl: ".multipleslider-next",
      },
      loop: true,
    });

    let multipleChiffres = new Swiper(".slider-chiffres.-nologo", {
      modules: [Navigation, Controller],
      slidesPerView: 1,
      spaceBetween: 20,
      speed: 2000,
      navigation: {
        nextEl: ".multipleslider-next",
      },
      loop: true,
    });

    multipleMain.controller.control = multipleChiffres;
    multipleChiffres.controller.control = multipleMain;

    const numberSlidesAttr = document.querySelector("#numberslidesmultiple");
    const dataSlides = numberSlidesAttr
      ? parseInt(numberSlidesAttr.getAttribute("data-slides"))
      : NaN;
    let numberSlides = dataSlides + 1;
    let slidesPerview = dataSlides <= 4 ? 3 : 5;

    if (document.querySelector(".slider-logos") && numberSlides) {
      let multipleLogos = new Swiper(".slider-logos", {
        centeredSlides: true,
        slidesPerView: slidesPerview,
        slideToClickedSlide: true,
        loop: true,
        speed: 2000,
        loopedSlides: numberSlides,
        spaceBetween: 10,
      });

      let multipleMainLogos = new Swiper(".slider-main.-logo", {
        modules: [Navigation],
        slidesPerView: 1,
        spaceBetween: 10,
        speed: 2000,
        navigation: {
          nextEl: ".multipleslider-next",
        },
        loop: "true",
        loopedSlides: numberSlides,
        preventClicks: true,
      });

      multipleMainLogos.controller.control = multipleLogos;
      multipleLogos.controller.control = multipleMainLogos;

      const sliderParamEl = document.querySelector(".slider-param");
      const sliderparam = sliderParamEl
        ? sliderParamEl.textContent.replace("/", "")
        : "";
      if (sliderparam) {
        const slideEl = document.querySelector(".swiper-slide." + sliderparam);
        const slide = slideEl
          ? parseInt(slideEl.getAttribute("data-slide")) - 1
          : 0;
        setTimeout(function () {
          multipleMainLogos.slideTo(slide);
        }, 175);
      }
    }
  }

  let sliderMarques = new Swiper(".slider-marques", {
    modules: [Autoplay],
    slidesPerView: 6,
    spaceBetween: 35,
    loop: true,
    breakpoints: {
      650: {
        slidesPerView: 3,
        // spaceBetween: 20
      },
      800: {
        slidesPerView: 4,
      },
      1024: {
        slidesPerView: 6,
      },
    },
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
    speed: 1000,
  });
}
